import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { DeviceStatusList } from '../components/device-status-list/device-status-list';
import NOB from '../../../constants/language-strings';
import * as action from '../actions';
import { requestUpdateDevicePollingMac, requestDevicePollingMac, } from '../actions/devicePollingMacActions';
import SlideInPage from '../../../components/SlideInPage/SlideInPage';
import Sam from './sam';
import Platform from '../../../constants/platform';
import { useWorkOrder } from 'modules/Workorder/api';
import { useLocation } from 'react-router';
import { HealthCheckHeader, HealthCheckList } from '../components/health-check';
import { InfoBox } from 'components/InfoBox/info-box';
import { PurPurButton } from 'components';
import styled from 'styled-components';
import { Skeleton } from '@purpurds/purpur/skeleton';
import spacing from 'theme/spacing';
import { HitDecoder } from '../provisioning';
import { SlideInModal } from 'components/slide-in-modal';
import { icons } from 'theme/icons';
import { purpurColorPurple800 } from '@purpurds/tokens/color/variables';
import { Icon } from '@purpurds/purpur/icon';
import { Spinner } from '@purpurds/purpur/spinner';
import DeviceHealthCheckContainer from '../device-health-check/device-health-check-container';
const HealthCheckWorkOrderDetails = styled.div `
  width: 100%;
  max-width: 750px;

  > div:first-of-type {
    margin-bottom: 10px;
  }
`;
const DeviceStatusContainer = styled.div `
  margin-bottom: 30px;
`;
const DeviceStatusHeading = styled.div `
  font-size: 20px;
  margin: ${spacing.spacing20} 0 0 ${spacing.spacing16};
`;
const ButtonWrapper = styled.div `
  display: flex;
  margin-bottom: 70px;
`;
const StyledSkeleton = styled(Skeleton) `
  width: 100%;
  height: 4rem;
  margin-top: ${spacing.spacing4};
`;
const StyledIcon = styled(Icon) `
  color: ${purpurColorPurple800};
  cursor: pointer;
  margin: 0 ${spacing.spacing4} ${spacing.spacing4} 0;
`;
const HealthCheckContainer = ({ requestHealthCheck, requestDevicePollingAllDevices, requestIccCheck, healthCheck, requestUpdateHealthCheck, devicePollingAllDevices, isFetching, isIccFetching, isFetchingProvisioning, devicePollingError, isUpdateFetching, devicePollingSingleDeviceError, requestUpdateDevicePollingSingleDevice, requestDevicePollingSingleDevice, languageStrings, }) => {
    var _a, _b, _c;
    const location = useLocation();
    const workOrderId = Number((_a = location.pathname.match(/workOrder\/(\d+)/)) === null || _a === void 0 ? void 0 : _a[1]);
    const customerInfoId = Number((_b = location.pathname.match(/customerInfo\/(\d+)/)) === null || _b === void 0 ? void 0 : _b[1]);
    const { workOrder } = useWorkOrder(workOrderId);
    const customerId = customerInfoId || ((_c = workOrder === null || workOrder === void 0 ? void 0 : workOrder.customer) === null || _c === void 0 ? void 0 : _c.customerId) || undefined;
    const [displaySam, setDisplaySam] = useState(false);
    const [displaySamDevice, setDisplaySamDevice] = useState(null);
    const [IsVisibleHitDecoderModal, setIsVisibleHitDecoderModal] = useState(false);
    useEffect(() => {
        if (!!customerId) {
            requestHealthCheck(customerId);
            requestDevicePollingAllDevices(customerId);
            requestIccCheck(customerId);
        }
    }, [customerId]);
    const updateHealthCheck = () => {
        if (!customerId)
            return;
        const healthCheckIds = healthCheck.provisioning.healthCheckResponses
            .filter(filterResponse => filterResponse.canUpdate)
            .map(mapResponse => mapResponse.id);
        requestUpdateHealthCheck(customerId, healthCheckIds);
    };
    const toggleDisplaySam = (selectedProduct) => {
        setDisplaySam(!displaySam);
        if (selectedProduct) {
            setDisplaySamDevice(selectedProduct);
        }
        else {
            setDisplaySamDevice(null);
        }
    };
    const closeHealthCheckModal = () => {
        setDisplaySam(false);
        setDisplaySamDevice(null);
    };
    const refresh = () => new Promise(() => {
        if (!isUpdateFetching && !devicePollingSingleDeviceError && (displaySamDevice === null || displaySamDevice === void 0 ? void 0 : displaySamDevice.pollIdentifier)) {
            requestUpdateDevicePollingSingleDevice(displaySamDevice.pollIdentifier);
        }
        else {
            requestDevicePollingSingleDevice((displaySamDevice === null || displaySamDevice === void 0 ? void 0 : displaySamDevice.pollUrl) || '');
        }
    });
    return (_jsxs(SlideInPage, { mainHeading: NOB.HEALTH_CHECK.HEALTH_CHECK, showLeftIcon: true, children: [_jsxs(HealthCheckWorkOrderDetails, { children: [_jsx(HealthCheckHeader, { healthCheck: healthCheck, deviceCheck: devicePollingAllDevices.checkPassedStatus, isFetching: isFetching, isIccFetching: isIccFetching, isFetchingProvisioning: isFetchingProvisioning }), _jsx(HealthCheckList, { updateHealthCheck: updateHealthCheck, healthCheck: healthCheck, devicePollingCheckPassed: devicePollingAllDevices.checkPassed || false, isIccFetching: isIccFetching, isFetchingProvisioning: isFetchingProvisioning }), _jsxs(DeviceStatusContainer, { children: [_jsx(DeviceStatusHeading, { children: NOB.HEALTH_CHECK.DEVICE_STATUS }), isFetching && _jsx(StyledSkeleton, {}), devicePollingAllDevices.deviceStatus.length > 0 && !isFetching && (_jsx(DeviceStatusList, { devices: devicePollingAllDevices.deviceStatus, isFetching: isFetching, toggleDisplaySam: toggleDisplaySam, error: devicePollingError })), !devicePollingAllDevices.deviceStatus.length && !isFetching && (_jsx(InfoBox, { variant: !!devicePollingError ? 'error' : 'info', firstInfoBoxLine: !!devicePollingError ? devicePollingError : languageStrings.NO_DEVICES_FOUND }))] }), _jsx(ButtonWrapper, { children: _jsx(PurPurButton, { variant: "primary", onClick: () => {
                                setIsVisibleHitDecoderModal(state => !state);
                            }, fullWidth: true, children: "Reprovisjoner boks" }) })] }), 
            // TODO: Refactor HFC endpoint and remove this conditional render
            devicePollingAllDevices.platform.toUpperCase() === Platform.HFC ? (_jsx(SlideInModal, { display: displaySam, onClose: closeHealthCheckModal, mainHeading: displaySamDevice === null || displaySamDevice === void 0 ? void 0 : displaySamDevice.description, leftIcon: isUpdateFetching ? (_jsx(Spinner, { size: "xs" })) : (_jsx(StyledIcon, { svg: icons.sync, size: 'md', onClick: refresh })), children: (displaySamDevice === null || displaySamDevice === void 0 ? void 0 : displaySamDevice.pollUrl) && (_jsx(Sam, { pollUrl: displaySamDevice.pollUrl })) })) : (_jsx(DeviceHealthCheckContainer, { display: displaySam, device: displaySamDevice, onClose: closeHealthCheckModal })), _jsx(HitDecoder, { isVisible: IsVisibleHitDecoderModal, customerId: customerId, onClose: () => setIsVisibleHitDecoderModal(state => !state) })] }));
};
const mapStateToProps = (state) => ({
    devicePollingSingleDeviceError: state.devicePollingMac.errorMessage,
    devicePollingAllDevices: state.devicePollingCustomer.devicePollingCustomer,
    healthCheck: state.healthCheck,
    isIccFetching: state.healthCheck.isIccFetching,
    isFetching: state.devicePollingCustomer.isFetching,
    devicePollingError: state.devicePollingCustomer.errorMessage,
    isFetchingProvisioning: state.healthCheck.isFetching,
    isUpdateFetching: state.updateDevicePollingMac.isFetching,
    languageStrings: state.NOB.HEALTH_CHECK,
});
const mapDispatchToProps = (dispatch) => ({
    requestHealthCheck: (customerId) => dispatch(action.requestHealthCheck({ customerId })),
    requestUpdateHealthCheck: (customerId, healthCheckIds) => dispatch(action.requestUpdateHealthCheck({ customerId, healthCheckIds })),
    requestDevicePollingAllDevices: (customerId) => dispatch(action.requestDevicePollingCustomer({ customerId })),
    requestIccCheck: (customerId) => dispatch(action.requestIccCheck(customerId)),
    requestUpdateDevicePollingSingleDevice: (macAddress) => dispatch(requestUpdateDevicePollingMac({ macAddress })),
    requestDevicePollingSingleDevice: (pollUrl) => dispatch(requestDevicePollingMac(pollUrl)),
});
export default connect(mapStateToProps, mapDispatchToProps)(HealthCheckContainer);
